const React = require('react');
const { connect } = require('react-redux');
const { context } = require('app-context');
const Frame = require('../../components/Chat/Frame');
const {
    canLoadAnnouncementChat,
    dependencyPropTypes,
    hasAnnouncementChatDependencies
} = require('./announcement-chat-dependencies');

const selectors = context.selectors.all;
const actions   = context.actions;
const handlers  = context.handlers;

const internals = {};

const emptyChatInfoPillStyle = {
    display: 'inline-block',
    width: 'auto',
    textAlign: 'center',
    padding: '.75rem',
    margin: '.5rem',
    backgroundColor: '#f3f3f3',
    borderRadius: 20,
    color: '#444444',
    fontWeight: 400
};

const renderEmptyChatInfoPill = (message) => React.createElement('span', {
    style: emptyChatInfoPillStyle
}, message);

internals.mapStateToProps = (state, { match: { params } }) => {

    const groupUsers = selectors.getClassUsers_forChatByClassId(state, params.id) || [];
    const currentUser = selectors.getCurrentUser(state)?.user();
    const usersNameMap = groupUsers.reduce((collector, user) => {

        collector[user.id] = `${user.firstName} ${user.lastName}`;
        return collector;
    }, {});

    if (currentUser && !usersNameMap[currentUser.id]) {
        usersNameMap[currentUser.id] = `${currentUser.firstName} ${currentUser.lastName}`;
    }

    const frameProps = {
        classId: params.id,
        messages: selectors.getAnnouncementMessages_forChat_byId(state, params.id) || [],
        hasUnreadMessages: selectors.hasUnreadMessages(state, params.id),
        emptyChatInfo: renderEmptyChatInfoPill('There are no announcements yet'),
        group: selectors.getGroup_forAnnouncementChat(state, params.id) || {},
        users: groupUsers,
        usersNameMap,
        ga: {
            onSubmitMessage: ['sent class message', 'class: sent message']
        },
        isOffline: selectors.getIsOffline(state),
        includeEveryoneMention: true,
        rolePermissions: selectors.getCurrentUserRolePermissions(state),
        rolesInteractions: selectors.getCurrentUserRoleInteractions(state),
        role: selectors.getCurrentUserRole(state),
        chatText: selectors.getChatTextBySid(state, params.id) || '',
        sid: params.id,
        announcementConversation: selectors.getAnnouncementConversationByClassId(state, params.id),
        isAnnouncement: true,
        type: 'group',
        useProfanityFilter: selectors.getShouldUseProfanityFilter(state),
        conversationStarters: selectors.getAllConversationStarters(state),
        userIsInClass: selectors.currentUserIsInClass(state, params.id),
        currentUser,
        getCurrentListeningChannel: handlers.communication.getCurrentChannelSid,
        startListeningChannel: handlers.communication.startListeningAnnouncementMessages,
        stopListeningChannel: handlers.communication.stopListeningAnnouncementMessages,
        collapseHeaders: selectors.getCollapseHeaders_forGroups(state),
        schoolEnableReactions: false,
        schoolEnableGroupGifs: selectors.getSchoolEnableGroupGifs(state),
        schoolEnableDmGifs: selectors.getSchoolEnableDmGifs(state),
        debug: selectors.getDebug(state).chat
    };

    return {
        ...frameProps,
        canLoadChat: canLoadAnnouncementChat(frameProps),
        dependenciesReady: hasAnnouncementChatDependencies(frameProps)
    };
};

internals.mapDispatchToProps = {
    onSubmitMessage: actions.communication.sendAnnouncementMessage,
    onSaveMessage: actions.communication.updateAnnouncementMessageBody,
    onModerateMessage: actions.communication.moderateAnnouncementMessage,
    onPinMessage: actions.communication.pinAnnouncementMessage,
    onRemoveMessage: actions.communication.removeAnnouncementMessage,
    onRemoveOwnMessage: actions.communication.removeAnnouncementMessage,
    onSetAnnouncementLastReadMessageIndex: actions.communication.setAnnouncementLastReadMessageIndex,
    onFlagInappropriate: actions.communication.flagAnnouncementMessageAsInappropriate,
    showNotification: (msg) => actions.alerts.notification.push({ message: msg }),
    onRequestMessages: ({ classId } = {}) => actions.dataFetching.fetchAnnouncementMessages({ id: classId }),
    setCollapseHeaders: (setting) => actions.chats.setCollapseHeadersGroups({ setting }),
    onUploadChatImage: actions.communication.uploadChatImage
};

const AnnouncementClassChatFrame = connect(
    internals.mapStateToProps,
    internals.mapDispatchToProps
)(Frame);

AnnouncementClassChatFrame.dependencyPropTypes = dependencyPropTypes;

module.exports = AnnouncementClassChatFrame;

if (process.env.NODE_ENV === 'test') {
    module.exports._internals = internals;
}
